export const colors = {
  primary: '#2ec4b6',
  primaryHover: '#228f85',
  primaryDisabled: 'rgba(46, 196, 182, 0.2)',
  primaryOpacity: '#e1f1f0',
  secondary: '#ff6a56',
  secondaryHover: '#e6513d',
  secondaryDisabled: 'rgba(255, 106, 86, 0.2)',
  accentBlue: '#0080ff',
  accentPurple: '#8a40f6',
  accentGreen: '#67EF84',
  accentOrange: '#F18303',
  white: '#ffffff',
  pearl: '#fafafa',
  riverstone: '#f2f3f7',
  aliceblue: '#f8f9fb',
  athensgray: '#edecee',
  cloud: '#f0f0f0',
  smoke: '#dddddd',
  gray: '#808080',
  ash: '#666666',
  charcoal: '#4c4c4c',
  palegreen: '#ecf3f3',
  success: '#39cb7b',
  error: '#f95541',
  warning: '#f9c107',
  darkgray: '#292829',
  midnightExpress: '#16223F',
  darkCerulean: '#0A4877',
  darkblue: '#093B61',
  strokeblue: '#85C0CD',
  lightblue: '#EFFFFF',
  black: '#000',
  northrend: '#B2F0FF',
  primaryBlue: '#C9E9E6',
  edgewater: '#C6E0DD',
  gunPowder: '#4c4d5b',
  whiteIce: '#ecf8f6',
  darkSilver: '#707070',
  rowRed: '#FFF6F6',
  rowOrange: '#FFF1E1',
  eclipse: '#373737',
  // new branding
  mossGreen: '#9DD29C',
  fennel: '#E1F6E4', // lighter mossGreen
  greatGreen: '#378040', // darker mossGreen
  deepTeal: '#003333',
  robinsEggBlue: '#02C6E6',
  turbo: '#F3EB04',
  carnelian: '#BA1A1A',
  geyser: '#D2DADE',
} as const;

export type ColorType = {};
